import { config } from '../../config/config';
import { Observable } from 'rxjs';
import { utilService } from '../utils';

function getUpcomingTasks(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.upcoming_tasks, {
      method: 'POST',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // username, course, course_id, task_name, task_desciption, set_date, due_date, course_assessments_url
        // result.responceObject.records = [
        //   {
        //     course: '1',
        //     task: 'task 01',
        //     description: 'first task ever',
        //     status: 'Open',
        //     set: '01-01-2021',
        //     due: '31-12-2021',
        //   },
        //   {
        //     course: '2',
        //     task: 'task 02',
        //     description: 'another task',
        //     status: 'Due',
        //     set: '01-01-2021',
        //     due: '31-12-2021',
        //   },
        //   {
        //     course: '3',
        //     task: 'task 03',
        //     description: 'task #3',
        //     status: 'Open',
        //     set: '01-01-2021',
        //     due: '31-12-2021',
        //   },
        //   {
        //     course: '4',
        //     task: 'task 04',
        //     description: 'this is the fourth task',
        //     status: 'Due',
        //     set: '01-01-2021',
        //     due: '31-12-2021',
        //   },
        //   {
        //     course: '5',
        //     task: 'task 05',
        //     description: 'final task',
        //     status: 'Open',
        //     set: '01-01-2021',
        //     due: '31-12-2021',
        //   },
        // ];
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        console.error(error);
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

export const upcomingTasksService = {
  getUpcomingTasks: getUpcomingTasks,
};
